import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AuthEffects, authGuideReducer } from './store';

@NgModule({
  imports: [EffectsModule.forFeature([AuthEffects]), StoreModule.forFeature(`guide`, authGuideReducer)]
})
export class AuthGuideStateModule {}
